import React from 'react';
import { connect } from 'redux-bundler-react';

const PageProductsContainer = ({
  pageProductsRaw: {
    data: { hasMoreProducts, products },
    isFetching,
  },
  doFetchMorePageProducts,
  children,
}) =>
  children({
    products,
    isFetching,
    hasMoreProducts,
    doFetchMorePageProducts,
  });

export default connect(
  'selectPageProductsRaw',
  'doFetchMorePageProducts',
  PageProductsContainer,
);
